// Ошибка API поверх huma problem+json. Несёт HTTP-статус, стабильный доменный
// code (EVENT_NOT_FOUND, EVENT_PAST, BOOKING_TIME_CONFLICT, FORBIDDEN, …) и detail —
// по ним UI разводит 403-экран, конфликт версий, тосты.

interface ProblemBody {
  status?: number
  title?: string
  detail?: string
  code?: string
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string | undefined
  readonly detail: string | undefined

  constructor(status: number, message: string, code?: string, detail?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.detail = detail
  }

  static from(response: Response, body: unknown): ApiError {
    const problem = (body ?? {}) as ProblemBody
    const message = problem.detail || problem.title || `HTTP ${response.status}`
    return new ApiError(response.status, message, problem.code, problem.detail)
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }

  get isForbidden(): boolean {
    return this.status === 403
  }

  get isConflict(): boolean {
    return this.status === 409
  }
}
